export { default as CubeTransparentSolidIcon } from './CubeTransparentSolidIcon';
